// Mouvement de l'export vidéo de la page Sillage : reprend la veille
// automatique du plein écran (rotation lente, inclinaison, respiration du
// zoom, cf. updateAutoIdle dans sillageMain.js) mais en boucle parfaite --
// la dernière image retombe exactement sur la première, la vidéo peut
// tourner à l'infini sans à-coup (demande Rudy, 17 octobre 2026).
//
// Durée = un tour complet du globe à la vitesse réelle de la page (~140 s),
// puis chaque mouvement est ajusté au plus près du réel pour revenir à son
// point de départ en fin de vidéo :
// - zoom : nombre entier de respirations (4 de ~35 s, contre 34 s en vrai) ;
// - inclinaison : sur la page elle avance sans fin, ici elle oscille avec la
//   même vitesse de départ (sinon elle ne reviendrait jamais au départ) ;
// - rotation propre de l'orbe : arrondie au nombre de tours entier le plus
//   proche (réglage de prod du 17 octobre 2026 : 1 au lieu de ~1,1) ;
// - bruit des particules : sur la page il glisse en ligne droite (la forme
//   de l'orbe ne se répète jamais), ici il suit un cercle de même vitesse,
//   tangent à la ligne droite au départ.
//
// Toutes les valeurs renvoyées sont des écarts par rapport à l'état de la
// vue au lancement de l'export.

const TAU = Math.PI * 2;

export function buildSillageLoop({
  fps, yawSpeed, tiltSpeed, zoomPeriodS, zoomAmplitude, sphereRotSpeed, noiseSpeed,
}) {
  // Nombre d'images entier, puis durée recalculée dessus : l'image n°
  // totalFrames (non encodée) est exactement l'image 0.
  const totalFrames = Math.round((TAU / yawSpeed) * fps);
  const duration = totalFrames / fps;
  const zoomWaves = Math.max(1, Math.round(duration / zoomPeriodS));
  const sphereTurns = Math.round((sphereRotSpeed * duration) / TAU);
  const tiltAmplitude = (tiltSpeed * duration) / TAU;
  const noiseRadius = (noiseSpeed * duration) / TAU;

  function stateAt(time) {
    const phase = (TAU * time) / duration;
    return {
      yaw: phase,
      tilt: tiltAmplitude * Math.sin(phase),
      zoom: 1 + zoomAmplitude * Math.sin(zoomWaves * phase),
      sphereRotation: sphereTurns * phase,
      // Départ dans la direction +z, celle du glissement sur la page.
      noiseOffset: [noiseRadius * (1 - Math.cos(phase)), 0, noiseRadius * Math.sin(phase)],
    };
  }

  return { totalFrames, duration, zoomWaves, sphereTurns, stateAt };
}
